var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row border m-0 rounded" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          key: option.label,
          staticClass: "col-sm-12 py-2",
          class: option.cols ? option.cols : "col"
        },
        [
          _c("check-box", {
            attrs: { text: option.label },
            model: {
              value: option.value,
              callback: function($$v) {
                _vm.$set(option, "value", $$v)
              },
              expression: "option.value"
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }